import { render, staticRenderFns } from "./ComplieRightMenu.vue?vue&type=template&id=67e91b4b&scoped=true"
import script from "./ComplieRightMenu.vue?vue&type=script&lang=js"
export * from "./ComplieRightMenu.vue?vue&type=script&lang=js"
import style0 from "./ComplieRightMenu.vue?vue&type=style&index=0&id=67e91b4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e91b4b",
  null
  
)

export default component.exports